import getOffset from '../utils/getOffset'
import withScroll from '../hoc/withScroll'
import emitter from '../utils/emitter'
import onResize from '../utils/onResize'

export default withScroll({
  name: 'timeline',

  infosScroll: [],

  ui: {
    rail: '[js-timeline-rail]',
    current: '[js-timeline-current]',
    currentLine: '[js-timeline-current-line]',
    'infos[]': '[js-timeline-infos]',
    years: '[js-timeline-years]',
    mobileLine: '[js-timeline-mobile-line]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    // mobile line
    emitter.on('change_slide', data => {
      this.ui.mobileLine.style.width = `${(100 / (data.totalSlides - 1)) * data.currentSlide}%`

      if (data.currentSlide === data.totalSlides - 1) {
        this.ui.mobileLine.parentNode.classList.add('is-end')
      } else {
        this.ui.mobileLine.parentNode.classList.remove('is-end')
      }
    })

    // setTimeout(() => {
    //   this.calc()
    // }, 5000)
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.calc()
  },

  calc () {
    this.offsetTop = getOffset(this.el) - 40
    this.bottom = this.offsetTop + this.el.offsetHeight - window.innerHeight - 192 - 150

    this.offsetTranslate = 120

    if (window.innerWidth >= 1024) {
      this.offsetTranslate = 160
    }

    this.infosScroll = []

    this.ui.infos.forEach(info => {
      const offsetTop = getOffset(info)

      this.infosScroll.push({
        offsetTop: offsetTop,
        offsetBottom: offsetTop + info.offsetHeight,
      })
    })
  },

  onScroll ({ y }) {
    if (window.innerWidth >= 768) {
      // current point + line
      if (y >= this.offsetTop) {
        let percent = ((y - this.offsetTop) * 100) / this.bottom

        if (percent > 100) percent = 100

        this.ui.current.style.top = `${percent}%`
        this.ui.currentLine.style.height = `${percent}%`

        // change year based on current infos displayed
        for (let i = 0; i < this.infosScroll.length; i++) {
          if (y + (window.innerHeight * 0.5) >= this.infosScroll[i].offsetTop && y + (window.innerHeight * 0.5) < this.infosScroll[i].offsetBottom) {
            this.ui.years.style.transform = `translateY(-${i * this.offsetTranslate}px)`
            break
          }
        }
      } else {
        this.ui.current.style.top = 0
        this.ui.currentLine.style.height = 0
        this.ui.years.style.transform = 'translateY(0)'
      }
    }
  },
})
